module.exports = __webpack_public_path__ + "static/media/thaiagro.22174e59.png";